const heroImg =
  "https://readdy.ai/api/search-image?query=editorial%20close%20up%20of%20a%20vintage%20brass%20alarm%20clock%20and%20torn%20newspaper%20clippings%20pinned%20by%20red%20tape%20on%20a%20studio%20desk%2C%20warm%20tungsten%20light%2C%20matte%20analog%20film%20grain%2C%20muted%20cream%20terracotta%20and%20charcoal%20palette%2C%20magazine%20cover%20editorial%20composition%2C%20soft%20shadow%2C%20high%20detail&width=1500&height=1120&seq=hero-911-open&orientation=portrait";

export default function Hero() {
  return (
    <section id="top" className="mx-auto max-w-6xl px-4 pt-8 md:px-6 md:pt-12">
      {/* kicker */}
      <div className="mb-5 flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-muted">
        <span className="inline-flex h-1.5 w-1.5 animate-pulse rounded-full bg-accent" />
        <span>头版 · 911网第一时间现场</span>
        <span className="hidden text-line-strong sm:inline">/</span>
        <span className="hidden whitespace-nowrap sm:inline">为直接上第一轮现场的人准备</span>
      </div>

      <div className="grid gap-10 lg:grid-cols-[1.05fr_1fr] lg:gap-14">
        {/* 文页 */}
        <div className="flex flex-col">
          <h2 className="font-display text-[2rem] font-black leading-[1.15] tracking-tight text-ink sm:text-5xl md:text-[3.4rem]">
            不等二传再汇总，
            <br />
            第一时间 <span className="text-accent">先上现场</span>。
          </h2>

          {/* 双栏文 */}
          <p className="mt-6 max-w-none columns-1 gap-8 text-[15px] leading-7 text-ink/85 sm:columns-2">
            进站就能看到正在发生的<strong className="text-accent-deep">911网新瓜</strong>和碎片。突发消息进来，我们先把原貌收好、编号、排上时间轴，再把第一轮现场直接给你——不用绕完所有渠道再回头等二传。
            <span className="mt-4 block">
              这儿只发能对得上源头的说法，对不上的挂“待核实”，翻案会原条标灰并附更正。你要的判断依据和改判理由，都在正文里摊着。
            </span>
          </p>

          <div className="mt-8 flex items-center gap-3 text-sm text-muted">
            <span>主编 · 第 214 轮发稿</span>
            <span className="text-line-strong">/</span>
            <span>今天 10:41 更新</span>
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#timeline"
              className="inline-flex whitespace-nowrap items-center justify-center rounded-md bg-accent px-6 py-3 text-sm text-white transition-colors hover:bg-accent-deep"
            >
              追 911网 最新消息
              <i className="ri-arrow-right-line ml-2 text-[15px]" />
            </a>
            <a
              href="#live"
              className="inline-flex whitespace-nowrap items-center justify-center rounded-md border border-line-strong px-6 py-3 text-sm text-ink transition-colors hover:border-accent hover:text-accent"
            >
              先看正在发生
            </a>
          </div>

          <div className="mt-8 flex flex-wrap gap-x-5 gap-y-2 text-xs text-muted">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-[13px] text-marker" /> 来源可追溯
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-time-line text-[13px] text-marker" /> 每条带时间轴
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-eraser-line text-[13px] text-marker" /> 翻案会原条更正
            </span>
          </div>
        </div>

        {/* 图页对开 */}
        <figure className="group relative flex flex-col overflow-hidden rounded-lg bg-paper-2">
          <div className="relative h-[420px] w-full overflow-hidden sm:h-[520px] lg:h-full lg:min-h-[640px]">
            <img
              src={heroImg}
              alt="911网 第一时间紧急爆料现场"
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
            />
            <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-md bg-accent px-2.5 py-1 text-xs font-medium text-white">
              <span className="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-white" /> LIVE
            </span>
          </div>
          <figcaption className="flex items-center justify-between gap-3 border-t border-line bg-paper-2 px-5 py-4 text-xs text-muted">
            <span className="flex items-center gap-2">
              <i className="ri-camera-lens-line text-[14px]" /> 第一轮现场 · 图片仅作栏目示意
            </span>
            <span className="hidden whitespace-nowrap sm:inline">№ 214 · 轮次仍在进行</span>
          </figcaption>
        </figure>
      </div>
    </section>
  );
}